export enum TranslationKeys {
  columnPartnerId = 'jbp-spt-partner-id-column',
  columnLocationId = 'jbp-spt-location-id-column',
  columnPartnerName = 'jbp-spt-partner-name-column',
  columnMarket = 'jbp-spt-market-column',
  columnCountry = 'jbp-spt-country-column',
  columnHierarchy = 'jbp-spt-hierarchy-column',
  columnCompletion = 'jbp-spt-completion-column',
  partnerTableSave = 'jbp-spt-partner-table-save',
  partnerTableDelete = 'jbp-spt-partner-table-delete',
  bulkSave = 'jbp-spt-bulk-save',
  bulkClear = 'jbp-spt-bulk-clear',
}
